import { INSERT_AND_UPDATE_PHOTOGRAPHY_AND_VIDEOGRAPHY_ACTION_TYPE, GET_PHOTOGRAPHY_AND_VIDEOGRAPHY_DETAILS_ACTION_TYPE } from "../../../../../utils/constants";

const initialState = [];

function photographyAndVideographyReducer(state = initialState, action) {
    const { type, payload } = action

    switch (type) {
        case INSERT_AND_UPDATE_PHOTOGRAPHY_AND_VIDEOGRAPHY_ACTION_TYPE:
            return [...state, payload];
        case GET_PHOTOGRAPHY_AND_VIDEOGRAPHY_DETAILS_ACTION_TYPE:
            return [...state, payload];

        default:
            return state;
    }
};

export default photographyAndVideographyReducer;
